module.exports = __webpack_public_path__ + "img/joyride.2a19d994.svg";